export default "__VITE_ASSET__iLgRcS$2__"